/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const EyeHiddenIcon = /*#__PURE__*/ createSvgIcon(
  'EyeHiddenIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M12.48 7.52c.29.293.527.643.707 1.053.181.41.285.837.313 1.281a.716.716 0 01-.223.531.728.728 0 01-.527.22.754.754 0 01-.546-.22.713.713 0 01-.225-.53 1.666 1.666 0 00-.094-.772 1.808 1.808 0 00-.385-.614 1.542 1.542 0 00-.594-.386c-.229-.083-.482-.11-.76-.083a.717.717 0 01-.532-.223.728.728 0 01-.218-.527c0-.208.073-.385.218-.531a.723.723 0 01.532-.219c.444.028.868.128 1.27.302a3.38 3.38 0 011.063.719zM10 5.5c-.232 0-.457.007-.677.022-.22.014-.439.041-.658.08a.924.924 0 01-.592-.112.729.729 0 01-.365-.459.72.72 0 01.073-.573.619.619 0 01.464-.317c.295-.052.587-.089.877-.11.29-.02.582-.031.878-.031 1.861 0 3.573.476 5.135 1.427 1.563.951 2.748 2.261 3.555 3.93.054.11.091.216.112.32a1.647 1.647 0 010 .646c-.02.104-.052.212-.094.323a7.567 7.567 0 01-.914 1.477c-.363.46-.76.89-1.19 1.294a.704.704 0 01-1.042-.087.725.725 0 01-.177-.552c.021-.2.108-.375.26-.528.362-.32.684-.667.967-1.042.283-.375.53-.777.742-1.208a7.692 7.692 0 00-3.01-3.302A8.266 8.266 0 0010 5.5zM10 16a9.216 9.216 0 01-5.02-1.448 10.361 10.361 0 01-3.607-3.848.939.939 0 01-.133-.34 2.1 2.1 0 010-.729.961.961 0 01.135-.343c.32-.625.693-1.209 1.12-1.75a9.42 9.42 0 011.463-1.48L2.396 4.5a.718.718 0 01-.23-.52c0-.195.077-.369.23-.522a.729.729 0 011.062 0l13.084 13.084c.152.152.229.326.229.52a.718.718 0 01-.23.521.73.73 0 01-1.062 0l-2.187-2.166A9.547 9.547 0 0110 16zM5.02 7.146c-.485.389-.937.816-1.353 1.281-.417.465-.757.99-1.021 1.573a7.692 7.692 0 003.01 3.302A8.266 8.266 0 0010 14.5a7.64 7.64 0 001.065-.073c.345-.048.692-.114 1.04-.198l-.938-.937c-.195.07-.39.121-.584.156A3.315 3.315 0 0110 13.5c-.972 0-1.799-.34-2.48-1.02-.68-.681-1.02-1.508-1.02-2.48 0-.194.024-.389.073-.583.048-.195.094-.39.135-.584L5.021 7.146z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default EyeHiddenIcon;
